exports.radicalListWithMeaning = {
"一":"one",
"丨":"line",
"丶":"dot",
"⺀":"dot",
"丿":"bend",
"乙":"second",
"⺃":"second",
"乚":"second",
"⺄":"second",
"亅":"hook",
"二":"two",
"亠":"lid",
"人":"human",
"亻":"human",
"⺅":"human",
"儿":"legs",
"入":"enter",
"八":"eight/divide",
"丷":"eight/divide",
"冂":"upside down box",
"⺆":"upsode down box",
"冖":"cover",
"冫":"ice",
"几":"table",
"⺇":"table",
"凵":"container",
"刀":"knife",
"刂":"knife",
"⺈":"knife",
"⺉":"knife",
"力":"power/force",
"勹":"wrap",
"匕":"spoon",
"匚":"box",
"匸":"hiding enclosure",
"十":"ten",
"卜":"divination",
"⺊":"divination",
"卩":"seal",
"⺋":"seal",
"厂":"cliff",
"⺁":"cliff",
"厶":"private",
"又":"right hand",
"口":"mouth",
"囗":"enclosure",
"土":"earth",
"士":"scholar",
"夂":"go",
"夊":"go slowly",
"夕":"evening/unset",
"大":"big",
"女":"woman",
"子":"child",
"宀":"roof",
"寸":"thumb",
"小":"small",
"⺌":"small",
"⺍":"small",
"尢":"lame",
"⺐":"lame",
"尣":"lame",
"⺑":"lame",
"⺎":"lame",
"尸":"corpse",
"屮":"sprout",
"山":"mountain",
"巛":"river",
"川":"river",
"巜":"river",
"工":"work",
"己":"oneself",
"巳":"oneself",
"⺒":"oneself",
"已":"oneself",
"巾":"turban/scarf",
"干":"dry",
"幺":"short/tiny",
"⺓":"short/tiny",
"广":"house on cliff",
"廴":"long stride",
"廿":"two hands/twenty",
"弋":"arrow",
"弓":"bow",
"彐":"pig snout",
"⺕":"pig snout",
"彑":"pig snout",
"⺔":"pig snout",
"彡":"bristle/beard",
"彳":"step",
"心":"heart",
"忄":"heart",
"⺗":"heart",
"戈":"spear",
"戶":"door/house",
"户":"door/house",
"戸":"door/house",
"手":"hand",
"扌":"hand",
"龵":"hand",
"⺘":"hand",
"支":"branch",
"攴":"knock",
"攵":"knock",
"⺙":"knock",
"文":"script/literature",
"斗":"dipper",
"斤":"axe",
"方":"square/raft",
"无":"have not",
"旡":"have not",
"⺛":"have not",
"日":"sun/day",
"⺜":"sun/day",
"曰":"say",
"月":"moon",
"⺝":"moon",
"木":"tree",
"欠":"yawn",
"止":"stop",
"歹":"death/decay",
"歺":"death/decay",
"⺞":"death/decay",
"殳":"weapon/lance",
"毋":"do not",
"母":"do not",
"⺟":"do not",
"比":"compare/compete",
"毛":"fur/hair",
"氏":"clan",
"气":"steam/breath",
"水":"water",
"氵":"water",
"氺":"water",
"⺢":"water",
"火":"fire",
"灬":"fire",
"⺣":"fire",
"爪":"claw/talon",
"⺤":"claw/talon",
"爫":"claw/talon",
"⺥":"claw/talon",
"父":"father",
"爻":"mix/twine/cross",
"爿":"split wood",
"丬":"split wood",
"⺦":"split wood",
"片":"a slice",
"牙":"fang",
"牛":"cow",
"牜":"cow",
"⺧":"cow",
"犬":"dog",
"犭":"dog",
"⺨":"dog",
"玄":"dark/profound",
"玉":"jade",
"⺩":"jade",
"玊":"jade",
"王":"jade",
"瓜":"melon",
"瓦":"tile",
"甘":"sweet",
"生":"life",
"用":"use",
"甩":"throw",
"田":"field",
"疋":"bolt of cloth",
"⺪":"bolt of cloth",
"疒":"sickness",
"癶":"footsteps",
"白":"white",
"皮":"skin",
"皿":"dish",
"目":"eye",
"⺫":"eye",
"矛":"spear",
"矢":"arrow",
"石":"stone",
"示":"sign",
"礻":"sign",
"⺭":"sign",
"⺬":"sign",
"禸":"track",
"禾":"grain",
"穴":"cave",
"立":"stand erect",
"竹":"bamboo",
"⺮":"bamboo",
"米":"rice",
"糸":"silk",
"糹":"silk",
"纟":"silk",
"⺯":"silk",
"⺰":"silk",
"缶":"jar",
"网":"net",
"罒":"net",
"⺲":"net",
"罓":"net",
"⺵":"net",
"⺳":"net",
"⺱":"net",
"⺴":"net",
"羊":"sheep",
"⺶":"sheep",
"⺷":"sheep",
"羽":"feather",
"老":"old",
"耂":"old",
"⺹":"old",
"而":"beard",
"耒":"plow",
"耳":"ear",
"聿":"brush",
"⺺":"brush",
"⺻":"brush",
"肉":"meat",
"⺼":"meat",
"臣":"minister/official",
"自":"self",
"至":"arrive",
"臼":"mortar",
"⺽":"mortar",
"舌":"tongue",
"舛":"opposite",
"舟":"boat",
"艮":"stopping",
"色":"color/prettiness",
"艸":"grass",
"艹":"grass",
"⺾":"grass",
"⺿":"grass",
"⻀":"grass",
"虍":"tiger stripes",
"虫":"insect",
"血":"blood",
"行":"go/do",
"衣":"clothes",
"衤":"clothes",
"⻂":"clothes",
"西":"west",
"⻄":"west",
"襾":"west",
"覀":"west",
"⻃":"west",
"見":"see",
"见":"see",
"⻅":"see",
"角":"horn",
"⻆":"horn",
"⻇":"horn",
"言":"speech",
"訁":"speech",
"讠":"speech",
"⻈":"speech",
"谷":"valley",
"豆":"bean",
"豕":"pig",
"豸":"cat/badger",
"貝":"shell",
"贝":"shell",
"⻉":"shell",
"赤":"red/bare",
"走":"run",
"赱":"run",
"足":"foot",
"⻊":"foot",
"身":"body",
"車":"car",
"车":"car",
"⻋":"car",
"辛":"bitter",
"辰":"morning",
"辵":"walk",
"辶":"walk",
"⻌":"walk",
"⻍":"walk",
"⻎":"walk",
"邑":"town",
"阝":"town",
"⻏":"town",
"酉":"wine/alcohol",
"釆":"distinguish/choose",
"里":"village/mile",
"金":"metal/gold",
"釒":"metal/gold",
"钅":"metal/gold",
"⻐":"metal/gold",
"長":"long/grow",
"镸":"long/grow",
"长":"long/grow",
"⻑":"long/grow",
"⻒":"long/grow",
"⻓":"long/grow",
"門":"gate",
"门":"gate",
"⻔":"gate",
"阜":"mound/dam",
"⻖":"mound/dam",
"⻕":"mound/dam",
"隶":"slave/capture",
"隹":"small bird",
"雨":"rain",
"⻗":"rain",
"青":"green/blue",
"靑":"green/blue",
"⻘":"green/blue",
"非":"wrong",
"面":"face",
"靣":"face",
"革":"leather",
"韋":"tanned leather",
"韦":"tanned leather",
"⻙":"tanned leather",
"韭":"leek",
"音":"sound",
"頁":"leaf",
"页":"leaf",
"⻚":"leaf",
"風":"wind",
"风":"wind",
"⻛":"wind",
"飛":"fly",
"飞":"fly",
"⻜":"fly",
"食":"eat/food",
"⻝":"eat/food",
"饣":"eat/food",
"⻞":"eat/food",
"⻟":"eat/food",
"⻠":"eat/food",
"首":"head",
"⻡":"head",
"香":"fragrant",
"馬":"horse",
"马":"horse",
"⻢":"horse",
"骨":"bone",
"⻣":"bone",
"高":"tall",
"髙":"tall",
"髟":"hair",
"鬥":"fight",
"鬯":"herbs/sacrificial wine",
"鬲":"tripod/cauldron",
"鬼":"ghost/demon",
"⻤":"ghost/demon",
"魚":"fish",
"鱼":"fish",
"⻥":"fish",
"鳥":"bird",
"鸟":"bird",
"⻦":"bird",
"鹵":"salt",
"卤":"salt",
"⻧":"salt",
"鹿":"deer",
"麥":"wheat",
"麦":"wheat",
"⻨":"wheat",
"麻":"hemp",
"黃":"yellow",
"⻩":"yellow",
"黍":"millet",
"黑":"black",
"黹":"embroidery",
"黽":"frog",
"黾":"frog",
"⻪":"frog",
"鼎":"sacrificial tripod",
"鼓":"drum",
"鼠":"rat/mouse",
"鼻":"nose",
"齊":"even/uniformly",
"⻫":"even/uniformly",
"齐":"even/uniformly",
"⻬":"even/uniformly",
"齒":"tooth/molar",
"齿":"tooth/molar",
"⻭":"tooth/molar",
"⻮":"tooth/molar",
"龍":"dragon",
"龙":"dragon",
"⻰":"dragon",
"⻯":"dragon",
"龜":"turtle",
"龟":"turtle",
"⻱":"turtle",
"⻲":"turtle",
"⻳":"turtle",
"龠":"flute",
"𠂇":"left hand"
};